// extracted by mini-css-extract-plugin
export default {"pageTitle":"nzb0XG9SO8UXM8Bh"};